import logo from "../../../assets/images/logo.svg";

export default function Footer() {
    return (
        <footer className="bg-brand-darkest text-white sm:-ml-4 sm:-mr-4 max-w-screen">
            <div className="flex flex-col items-center justify-center gap-4 px-2 lg:px-32 py-8">
                <div className="flex flex-col gap-4 text-center items-center">
                    <div className="flex items-center gap-2">
                        <img src={logo} alt="logo" className="w-10 h-10" />
                        <h1 className="text-xl font-semibold">Teamly</h1>
                    </div>
                    <p className="text-gray-300">The best tournament app for your team.</p>
                </div>
                <div className="flex gap-4 items-center justify-center text-center">
                    <a href="/tos" className="text-gray-300 font-bold">Terms of Service</a>
                    <a href="/privacy" className="text-gray-300 font-bold">Privacy Policy</a>
                    <a href="/tos" className="text-gray-300 font-bold">Community Guidelines</a>
                </div>
            </div>
        </footer>
    );
}